import React from 'react'
import { ReactComponent as NoControlsSVG } from './no_controls_icon.svg'
import { large } from './styles'

export const NoControlsIcon = (): JSX.Element => {
  return <NoControlsSVG style={large} />
}
